const DEFAULT_AVATAR_COLOR = '#6b7280';

function getHash(value) {
  return [...value].reduce((hash, char) => {
    return (hash * 31 + char.charCodeAt(0)) >>> 0;
  }, 0);
}

function hslToHex(hue, saturation, lightness) {
  const chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  const second = chroma * (1 - Math.abs(((hue / 60) % 2) - 1));
  const match = lightness - chroma / 2;
  const channels =
    hue < 60
      ? [chroma, second, 0]
      : hue < 120
        ? [second, chroma, 0]
        : hue < 180
          ? [0, chroma, second]
          : hue < 240
            ? [0, second, chroma]
            : hue < 300
              ? [second, 0, chroma]
              : [chroma, 0, second];

  return `#${channels
    .map((channel) => {
      const hex = Math.round((channel + match) * 255).toString(16);
      return hex.padStart(2, '0');
    })
    .join('')}`;
}

function hexToRgb(hex) {
  const sanitized = hex.replace('#', '');
  const value =
    sanitized.length === 3
      ? sanitized
          .split('')
          .map((char) => char + char)
          .join('')
      : sanitized;

  const red = parseInt(value.substring(0, 2), 16);
  const green = parseInt(value.substring(2, 4), 16);
  const blue = parseInt(value.substring(4, 6), 16);

  return { red, green, blue };
}

function getTextColorForBackground(hex) {
  const { red, green, blue } = hexToRgb(hex);
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
  return luminance > 0.65 ? '#111111' : '#ffffff';
}

export function getAvatarColor(name) {
  const seed = (name || '').trim();

  if (!seed) {
    return DEFAULT_AVATAR_COLOR;
  }

  const hue = getHash(seed.toLowerCase()) % 360;
  return hslToHex(hue, 0.68, 0.38);
}

export function getAvatarStyles(name) {
  const backgroundColor = getAvatarColor(name);
  const textColor = getTextColorForBackground(backgroundColor);
  return {
    background: backgroundColor,
    backgroundColor,
    backgroundImage: 'none',
    color: textColor,
    '--avatar-bg': backgroundColor,
    '--avatar-color': textColor,
  };
}
